module.exports = __webpack_public_path__ + "img/dreamstime_m_149028302.5d6265e0.jpg";